import {Cards} from "../Card/Cards";

export let postSliderProps = {
    swiperPerViewSM: {
        type: Number,
        default: 1,
    },
    swiperPerViewMD: {
        type: Number,
        default: 3,
    },
    swiperPerViewLG: {
        type: Number,
        default: 3,
    },
    postCard: {
        options: Object.keys(Cards),
        default: 'mPostCard2'
    },
    cardLink: {
        type: Boolean,
        default: true,
    },
}